import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationService } from './translation.service';
import { DynamicTranslationService } from './dynamic-translation.service';
import { TranslationCommunicationServiceService } from './translation-communication-service.service';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { TwoDigitDecimaNumberDirective } from './superadmin/two-digit-decima-number.directive';
import { QzTrayService } from '../app/qz-tray.service';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxGaugeModule } from 'ngx-gauge';
import { CodeInputModule } from 'angular-code-input';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../app/environments/environment';
import { BarcodeScannerLivestreamModule } from "ngx-barcode-scanner";
import { ReactiveFormsModule } from '@angular/forms';
import { RcsModule } from './rcs/rcs.module'
import { IgxDialogModule, IgxDragDropModule } from 'igniteui-angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { Daterangepicker } from 'ng2-daterangepicker';
import { Interceptor } from './Services/Interceptor';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxPermissionsModule } from 'ngx-permissions';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TwoDigitDecimaNumberDirective,
  ],

  imports: [MatStepperModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule, MatDatepickerModule, MatFormFieldModule, MatInputModule,
    MatNativeDateModule,
    BrowserModule,
    NgxUiLoaderModule,
    NgxUiLoaderHttpModule,
    CodeInputModule,
    BarcodeScannerLivestreamModule,
    NgxBarcodeModule,
    BrowserAnimationsModule,
    FormsModule,
    BrowserAnimationsModule,
    MatSelectModule,
    RcsModule,
    ReactiveFormsModule,
    IgxDragDropModule,
    IgxDialogModule,
    NgxGaugeModule,
    NgxPermissionsModule.forRoot(),
    NgxStripeModule.forRoot(environment.stripe_publish_key),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    ToastrModule.forRoot({
      preventDuplicates: true
    }),

    Daterangepicker,
    RouterModule.forRoot([
      { path: '', component: LoginComponent, pathMatch: 'full' },
    ]),

    BrowserAnimationsModule,

  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true }, DatePipe, TranslationService, DynamicTranslationService, TranslationCommunicationServiceService, QzTrayService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
